import React, { forwardRef, useEffect, useRef } from 'react';
import EmTplHtmlEditor, {
  EmTplHtmlEditorHandle,
  EmTplHtmlEditorProps,
} from './EmTplHtmlEditor';

const IfmsHtmlEditor = forwardRef<EmTplHtmlEditorHandle, EmTplHtmlEditorProps>(
  function IfmsHtmlEditor(props, ref) {
    const dummyInputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
    function handleFocusIn(e: FocusEvent) {
        const target = e.target as HTMLElement | null;
        if (target?.id !== 'ifms-app') return;

        // 팝업이 열렸을때는 Dummy Input으로 포커스 이동하지 않음
        const hasOpenOverlay = document.querySelector('.dx-overlay-wrapper');
        if (hasOpenOverlay) return;

      requestAnimationFrame(() => {
            const stillNoOverlay = !document.querySelector('.dx-overlay-wrapper');
            if (stillNoOverlay) {
            dummyInputRef.current?.focus();
            }
      });
    }

    document.addEventListener('focusin', handleFocusIn, true);
    return () => {
        document.removeEventListener('focusin', handleFocusIn, true);
    };
    }, []);

    return (
      <>
        <input
          ref={dummyInputRef}
          type="text"
          tabIndex={-1}
          readOnly
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: 1,
            height: 1,
            opacity: 0,
            border: 'none',
            padding: 0,
            pointerEvents: 'none',
          }}
        />
        <EmTplHtmlEditor ref={ref} {...props} />
      </>
    );
  }
);

export default IfmsHtmlEditor;
